export default function getResource(label, vars = []) {
    const resources = {
        myBasketLabel: 'My Basket',
        yourBasketLabel: 'Your Baskets'
    };

    return resources[label];
}
